import gql from "graphql-tag";

const getMinute = gql`
  query Query($args: FilterParamsInput) {
    searchMinutes(args: $args) {
      data {
        activities {
          additions {
            id
            name
            amount
            note
            comment
            type
            createdAt
            updatedAt
            deletedAt
            comments {
              id
              comment
              additionalId
              createdAt
              updatedAt
            }
            files {
              id
              name
              description
              path
              createdAt
            }
          }
          completed
          end_date
          history {
            id
            period
            planned
            executed
            createdAt
            updatedAt
            deletedAt
          }
          id
          initial_date
          name
          responsible {
            id
            name
            isValidator
            email
            position
          }
          validated
        }
        attachment
        description
        id
        name
        planId
        updatedAt
        validator {
          id
          isValidator
          name
          email
          position
        }
        validatorId
      }
      metadata {
        hasNextPage
      }
    }
  }
`;

export { getMinute }